export const KCAL_TO_KJ = 4.184;
export const ALCOHOL_VOLUMEN_TO_KCAL = 5.523;
export const SUGAR_GRAMS_PER_LITER_TO_KCAL = 0.387;
export const ORGANIC_ACID_GRAMS_PER_LITER_TO_KCAL = 0.31044;
export const POLYOL_GRAMS_PER_LITER_TO_KCAL = 0.2388;
export const LITER_TO_100ML = 10;
